import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
  deleteAddress, 
  setDefaultAddress 
} from '../../redux/accountSlice';
import AddressCard from './AddressCard';
import EmptyState from './EmptyState';
import AddressFormModal from './AddressFormModal';
import { MapPin } from 'lucide-react';

const AddressesTab = ({ token }) => {
  const dispatch = useDispatch();
  const { addresses, loading } = useSelector((state) => state.account);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);

  const openAddModal = () => {
    setSelectedAddress(null);
    setIsModalOpen(true);
  };

  const openEditModal = (addr) => {
    setSelectedAddress(addr);
    setIsModalOpen(true);
  };

  const handleDelete = async (addressId) => {
    if (window.confirm('Are you sure you want to delete this address?')) {
      try {
        await dispatch(deleteAddress({ addressId, token })).unwrap();
      } catch (err) {
        alert(err || 'Failed to delete address.');
      }
    }
  };

  const handleSetDefault = async (addressId) => {
    try {
      await dispatch(setDefaultAddress({ addressId, token })).unwrap();
    } catch (err) {
      alert(err || 'Failed to set default address.');
    }
  };

  if (loading && addresses.length === 0) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <h2 style={{ color: 'var(--color-text-primary)', fontSize: '1.8rem', margin: 0 }}>Saved Addresses</h2>
        <div className="addresses-grid">
          <div className="skeleton address-card-item" style={{ height: '200px' }} />
          <div className="skeleton address-card-item" style={{ height: '200px' }} />
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      
      {/* Title & Add Button */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 style={{ color: 'var(--color-text-primary)', fontSize: '1.8rem', margin: 0 }}>Saved Addresses</h2>
        <button onClick={openAddModal} className="btn">
          Add New Address
        </button>
      </div>

      {/* Grid of Addresses */}
      {addresses.length === 0 ? (
        <EmptyState
          icon={MapPin}
          title="No Saved Addresses"
          description="Please register your warehouse or shop delivery address details for future invoice generation and shipping operations."
          actionText="Add First Address"
          onActionClick={openAddModal}
        />
      ) : (
        <div className="addresses-grid">
          {addresses.map(addr => (
            <AddressCard
              key={addr._id}
              address={addr}
              onEdit={openEditModal}
              onDelete={handleDelete}
              onSetDefault={handleSetDefault}
            />
          ))}
        </div>
      )}

      {/* Reusable Address Form Modal */}
      <AddressFormModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        token={token}
        addressesLength={addresses.length}
        initialAddress={selectedAddress}
        onSuccess={() => setIsModalOpen(false)}
      />

    </div>
  );
};

export default AddressesTab;
